export default __webpack_public_path__ + "static/media/Sanathan-Textiles-Annual-Report-V4.5c76f486.pdf";